export default __webpack_public_path__ + "static/519-b0672a5fb9a4750f8f48692937e1dd82.gif";